import { render, staticRenderFns } from "./ProfileMissingSteps.vue?vue&type=template&id=6f8dc736&scoped=true&"
import script from "./ProfileMissingSteps.vue?vue&type=script&lang=js&"
export * from "./ProfileMissingSteps.vue?vue&type=script&lang=js&"
import style0 from "./ProfileMissingSteps.vue?vue&type=style&index=0&id=6f8dc736&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8dc736",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DashboardCard: require('/workspace/components/Dashboard/DashboardCard.vue').default})
